import { Items } from '@prisma/client';
import API_URL from '../apiconfig';
import { ItemForm, ItemWithCommissions, SearchItemsPage } from '../types/items';
import axios from './api';
import client from '../utils/react-query/client';

export async function getItems({
  businessId,
  includeDeleted,
}: {
  businessId: string;
  includeDeleted?: boolean;
}) {
  try {
    const response = await axios.get(`${API_URL}/v1/items`, {
      params: {
        businessId,
        includeDeleted,
      },
    });

    return response.data.result as ItemWithCommissions[];
  } catch (error) {
    throw new Error('Failed to get items');
  }
}

export async function searchItems({
  businessId,
  query,
  includeDeleted,
  cursor,
}: {
  businessId: string;
  query: string;
  includeDeleted?: boolean;
  cursor?: string;
}) {
  try {
    const response = await axios.get(`${API_URL}/v1/items/search`, {
      params: {
        businessId,
        includeDeleted,
        query,
        cursor: cursor || undefined,
      },
    });

    return response.data as SearchItemsPage;
  } catch (error) {
    throw new Error('Failed to get items');
  }
}

export async function createItem({
  businessId,
  payload,
}: {
  businessId: string;
  payload: ItemForm;
}) {
  try {
    const response = await axios.post(`${API_URL}/v1/items`, {
      businessId,
      ...payload,
    });

    return response.data.result as Items;
  } catch (error) {
    throw new Error('Failed to create item');
  }
}

export async function updateItem({
  itemId,
  businessId,
  payload,
}: {
  itemId: string;
  businessId: string;
  payload: ItemForm;
}) {
  try {
    const response = await axios.patch(`${API_URL}/v1/items/${itemId}`, {
      ...payload,
      businessId,
    });

    return response.data.result as Items;
  } catch (error) {
    throw new Error('Failed to update item');
  }
}

export async function invalidateItems() {
  await client.invalidateQueries({
    queryKey: ['retail-items'],
    exact: false,
  });
}

export async function deleteItem({ itemId }: { itemId: string }) {
  try {
    const response = await axios.delete(`${API_URL}/v1/items/${itemId}`);

    return response.data.result as boolean;
  } catch (error) {
    throw new Error('Failed to delete item');
  }
}

export async function invalidateSearchItems() {
  await client.invalidateQueries({
    queryKey: ['seach-retail-items'],
    exact: false,
  });
}
